<template>
  <div class="recharge-list-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose" :close-on-click-modal="false" class="el-dialogs">
     <div class="recharge-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input size="small" clearable placeholder="流水id" v-model="params.id" @keyup.native.enter="getPayHisList('status')" class="param-input" />
      <el-input size="small" clearable placeholder="用户id" @change="getPayHisList('status')" v-model.number="params.uid" @keyup.native.enter="getPayHisList('status')" class="param-input" />
      <el-input size="small" clearable placeholder="推广序列" v-model="params.promSeqe" @keyup.native.enter="getPayHisList('status')" class="param-input" />
        <el-select v-model="params.isDirect" clearable size="small" placeholder="用户类型" @change="getPayHisList('status')" >
          <el-option :value="true" label="直推用户"></el-option>
          <el-option :value="false" label="裂变用户"></el-option>
        </el-select>
        <el-select v-model="params.sysType" clearable size="small" placeholder="请选择系统类型" @change="getPayHisList('status')">
          <el-option v-for="item in ['android','ios']" :value="item" :label="item" :key="item"></el-option>
        </el-select>
        <el-date-picker v-model="params.time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
      <el-button type="primary" size="small" @click="getPayHisList('status')">搜索</el-button>
    </div>
    <div class="price-box">购买总金额: {{rchgordMoney  | numFormat}}元</div>
    <!--数据表格-->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
   
      <el-table-column prop="id" label="流水id" align="center" min-width="200" fixed>
        <template slot-scope="scope">
          <span>{{scope.row.id }}</span>
        </template>
      </el-table-column>
          <el-table-column prop="createdAt" label="创建时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="districtCode" label="商区码" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.districtCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户id" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.uid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="promSeqe" show-overflow-tooltip label="推广序列" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.promSeqe }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sysType" label="系统类型" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.sysType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isDirect" show-overflow-tooltip label="是直推用户" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.isDirect === true ? '是':'否'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="purchaseOrder" label="订单号" align="center" min-width="220">
        <template slot-scope="scope">
          <span>{{scope.row.purchaseOrder }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.amount +'元' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tranType" label="交易类型" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.tranType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.desc }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" align="center" fixed="right" width="130">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="editDesc(scope.row)"></el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
      <div class="zw"></div>
    </el-dialog>

  </div>
</template>
<script>
import { changeTime } from '@/utils/global';
import API from '@/api'
export default {
  data() {
    return {
      dialogVisible: false,
      title: '购买VIP记录',
       tableData: [],
      time: '',
      loading: false,
      rchgordMoney:0,
      total: 0,
      // 请求订单列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        id: '', //流水id
        time:'',
        uid: '', //用户UID
        promSeqe: '', //推广序列
        sysType: '', //系统类型
        isDirect: '', //是否是直推用户
        startTime: '',
        endTime: '',
        discCode:'',//商区码
      }
    }
  },
  methods: {
    // 请求订单列表
    getPayHisList(type) {
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      this.loading = true
      API.getPayHisList(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
          this.rchgordMoney = res.data.amountSum
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
      // 打开弹窗
    open(row) {
      this.dialogVisible = true;
      this.params.agent = row.agent;
      this.params.discCode =row.districtCode
      // this.params.discCode = row.districtCode
      this.getPayHisList();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params= {
        pageNumber: 1,
        pageSize: 10,
        id: '', //流水id
        uid: '', //用户UID
        time:'',
        promSeqe: '', //推广序列
        sysType: '', //系统类型
        isDirect: '', //是否是直推用户
        startTime: '',
        endTime: '',
        discCode:'',//商区码
      }
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getPayHisList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getPayHisList()
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || ''
        this.params.endTime = changeTime(time[1]) || ''
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.getPayHisList('status')
    },
  }
}
</script>
<style lang="scss">

.zw {
    height: 100px;
  }
</style>

